import type { DefaultSeoProps } from "next-seo";

const SEO: DefaultSeoProps = {
  title: "VacWork: The marketplace for piecemeal jobs & services",
  description:
    "VacWork connects employers and employees for flexible, piecemeal jobs and services. Discover, hire, and work with ease.",
  openGraph: {
    type: "website",
    locale: "en_ZA",
    url: "https://www.vacwork.app/",
    siteName: "VacWork",
    images: [
      {
        url: "https://www.vacwork.app/api/og",
        width: 1200,
        height: 630,
        alt: "VacWork Logo OG Image",
        type: "image/png",
      },
    ],
  },
  twitter: {
    handle: "@vacwork",
    site: "@vacwork",
    cardType: "summary_large_image",
  },
};

export default SEO;
